/**
 * Medico Header JS
 * - AJAX Live Search + Enter to search page
 * - Account popup
 * - Cart sidebar (live data from Shopify AJAX API)
 * - Compare sidebar
 * - Mobile drawer
 */

(function () {
  'use strict';

  /* ======================================================
     HELPERS
  ====================================================== */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function money(value, isCents) {
    if (isCents === undefined) isCents = true;
    var num = parseFloat(value) || 0;
    if (isCents) num = num / 100;
    
    var valueStr = num.toFixed(2);
    var format = (window.Medico && window.Medico.currency && window.Medico.currency.format) || "${{amount}}";
    
    // Simple shopify-style money formatter
    if (format.indexOf('{{amount}}') !== -1) {
      return format.replace('{{amount}}', valueStr);
    } else if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace('{{amount_no_decimals}}', Math.round(num));
    } else if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
      return format.replace('{{amount_with_comma_separator}}', valueStr.replace('.', ','));
    } else if (format.indexOf('{{amount_no_decimals_with_comma_separator}}') !== -1) {
      return format.replace('{{amount_no_decimals_with_comma_separator}}', Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    }
    
    return (window.Medico && window.Medico.currency && window.Medico.currency.symbol || '$') + valueStr;
  }

  /* ======================================================
     SEARCH
  ====================================================== */
  var searchDebounce;

  function initSearch(inputId, dropdownId, dropdownInnerId, submitId, clearId) {
    var input = qs('#' + inputId);
    var dropdown = qs('#' + dropdownId);
    var dropdownInner = qs('#' + dropdownInnerId);
    var submitBtn = qs('#' + submitId);
    var clearBtn = clearId ? qs('#' + clearId) : null;

    if (!input || !dropdown || !dropdownInner) return;

    // AJAX live search
    input.addEventListener('input', function () {
      var q = this.value.trim();
      if (clearBtn) clearBtn.style.display = q ? 'block' : 'none';
      clearTimeout(searchDebounce);
      if (q.length < 2) {
        dropdown.classList.remove('active');
        dropdownInner.innerHTML = '';
        return;
      }
      searchDebounce = setTimeout(function () {
        fetchSearchResults(q, dropdownInner, dropdown, input);
      }, 300);
    });

    // Enter key → navigate to search page
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = this.value.trim();
        if (q) {
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product,article,page';
        }
      }
      if (e.key === 'Escape') {
        dropdown.classList.remove('active');
        input.blur();
      }
    });

    // Submit button → navigate to search page
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var q = input.value.trim();
        if (q) {
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product,article,page';
        }
      });
    }

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        this.style.display = 'none';
        dropdown.classList.remove('active');
        dropdownInner.innerHTML = '';
        input.focus();
      });
    }

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (input && !input.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.classList.remove('active');
      }
    });
  }

  function fetchSearchResults(query, container, dropdown, input) {
    container.innerHTML = '<div class="search-loading">Searching...</div>';
    dropdown.classList.add('active');

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page&resources[limit]=5';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderSearchResults(data, query, container, dropdown);
      })
      .catch(function () {
        container.innerHTML = '<div class="search-no-results">Search error. Please try again.</div>';
      });
  }

  function renderSearchResults(data, query, container, dropdown) {
    var html = '';
    var resources = data.resources && data.resources.results ? data.resources.results : {};
    var products = resources.products || [];
    var pages = resources.pages || [];
    var collections = resources.collections || [];

    // Suggestions (collections as categories)
    if (collections.length > 0) {
      html += '<div class="search-section-label">Suggestions</div>';
      collections.forEach(function (col) {
        html += '<a href="' + col.url + '" class="search-suggestion">' + escHtml(col.title) + '</a>';
      });
    }

    // Pages
    if (pages.length > 0) {
      html += '<div class="search-section-label">Pages</div>';
      pages.forEach(function (page) {
        html += '<a href="' + page.url + '" class="search-suggestion">' + escHtml(page.title) + '</a>';
      });
    }

    // Products
    if (products.length > 0) {
      html += '<div class="search-section-label">Products</div>';
      products.forEach(function (product) {
        var imgUrl = product.featured_image ? product.featured_image.url : null;
        var comparePrice = product.compare_at_price_min && parseFloat(product.compare_at_price_min) > parseFloat(product.price_min)
          ? '<span class="search-product-compare">' + money(product.compare_at_price_min, false) + '</span>' : '';
        html += '<a href="' + product.url + '" class="search-product-item">'
          + (imgUrl
            ? '<img src="' + imgUrl + '" alt="' + escHtml(product.title) + '" class="search-product-img" width="52" height="52">'
            : '<div class="search-product-img-placeholder"></div>')
          + '<div class="search-product-info">'
          + '<div class="search-product-vendor">' + escHtml(product.vendor || '') + '</div>'
          + '<div class="search-product-title">' + escHtml(product.title) + '</div>'
          + '<div class="search-product-prices">'
          + '<span class="search-product-price">' + money(product.price_min, false) + '</span>'
          + comparePrice
          + '</div>'
          + '</div>'
          + '</a>';
      });
    }

    // View all
    if (products.length > 0 || pages.length > 0 || collections.length > 0) {
      html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product,article,page" class="search-view-all">'
        + 'Search for &ldquo;' + escHtml(query) + '&rdquo;'
        + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</a>';
    } else {
      html = '<div class="search-no-results">No results for &ldquo;' + escHtml(query) + '&rdquo;</div>';
    }

    container.innerHTML = html;
    dropdown.classList.add('active');
  }

  function escHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Init both desktop and mobile search
  initSearch('header-search-input', 'search-dropdown', 'search-dropdown-inner', 'search-submit-btn', 'search-clear-btn');
  initSearch('mobile-search-input', 'mobile-search-dropdown', 'mobile-search-dropdown-inner', 'mobile-search-submit', null);

  /* ======================================================
     ACCOUNT POPUP
  ====================================================== */
  function initAccountPopup(triggerId, popupId) {
    var trigger = qs('#' + triggerId);
    var popup = qs('#' + popupId);
    if (!trigger || !popup) return;
    var btn = trigger.querySelector('button') || trigger;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = popup.classList.contains('active');
      closeAllPopups();
      if (!open) {
        popup.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (!trigger.contains(e.target)) {
        popup.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        popup.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function closeAllPopups() {
    qsa('.account-popup').forEach(function (p) { p.classList.remove('active'); });
  }

  initAccountPopup('account-trigger', 'account-popup');
  initAccountPopup('mobile-account-trigger', 'mobile-account-popup');

  /* ======================================================
     CART SIDEBAR
  ====================================================== */
  var cartSidebar = qs('#cart-sidebar');
  var cartBody = qs('#cart-sidebar-body');
  var cartSubtotal = qs('#cart-subtotal-amount');
  var cartCount = qs('#cart-count');
  var sidebarOverlay = qs('#sidebar-overlay');

  function openSidebar(el) {
    closeAllSidebars();
    if (!el) return;
    el.classList.add('active');
    if (sidebarOverlay) sidebarOverlay.classList.add('active');
    document.body.classList.add('sidebar-open');
    el.setAttribute('aria-hidden', 'false');
  }

  function closeSidebar(el) {
    if (!el) return;
    el.classList.remove('active');
    el.setAttribute('aria-hidden', 'true');
    if (sidebarOverlay) sidebarOverlay.classList.remove('active');
    document.body.classList.remove('sidebar-open');
  }

  function closeAllSidebars() {
    qsa('.cart-sidebar, .compare-sidebar').forEach(function (s) {
      s.classList.remove('active');
      s.setAttribute('aria-hidden', 'true');
    });
    if (sidebarOverlay) sidebarOverlay.classList.remove('active');
    document.body.classList.remove('sidebar-open');
  }

  function openCart() {
    openSidebar(cartSidebar);
    loadCart();
  }

  function loadCart() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div class="cart-loading">Loading cart...</div>';
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function () {
        cartBody.innerHTML = '<div class="cart-empty"><p>Could not load cart.</p></div>';
      });
  }

  function renderCart(cart) {
    if (!cartBody) return;

    // Update count badge
    var count = cart.item_count || 0;
    qsa('.js-cart-count').forEach(function (el) { el.textContent = count; });

    if (count === 0) {
      cartBody.innerHTML = '<div class="cart-empty">'
        + '<svg width="48" height="48" viewBox="0 0 22 22" fill="none"><path d="M1 1h3l2.4 10.4a2 2 0 001.94 1.6h9.32a2 2 0 001.94-1.53L21 6H6" stroke="#ccc" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="19" r="1.5" fill="#ccc"/><circle cx="17" cy="19" r="1.5" fill="#ccc"/></svg>'
        + '<p>Your cart is empty.</p></div>';
      if (cartSubtotal) cartSubtotal.textContent = money(0);
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" class="cart-item__img" width="72" height="72">'
        : '<div class="cart-item__img-placeholder"></div>';

      html += '<div class="cart-item" data-key="' + item.key + '">'
        + imgHtml
        + '<div class="cart-item__info">'
        + '<div class="cart-item__vendor">' + escHtml(item.vendor || '') + '</div>'
        + '<a href="' + item.url + '" class="cart-item__title">' + escHtml(item.product_title) + '</a>'
        + '<div class="cart-item__price">' + money(item.price) + '</div>'
        + '<div class="cart-item__qty">'
        + '<button class="cart-item__qty-btn cart-qty-minus" data-key="' + item.key + '" aria-label="Decrease">−</button>'
        + '<input type="number" class="cart-item__qty-num" value="' + item.quantity + '" min="0" data-key="' + item.key + '" aria-label="Quantity">'
        + '<button class="cart-item__qty-btn cart-qty-plus" data-key="' + item.key + '" aria-label="Increase">+</button>'
        + '</div>'
        + '</div>'
        + '<div class="cart-item__actions">'
        + '<span class="cart-item__total">' + money(item.line_price) + '</span>'
        + '<button class="cart-item__delete" data-key="' + item.key + '" aria-label="Remove">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 4h10M5 4V2h4v2M6 7v4M8 7v4M3 4l1 8h6l1-8" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button>'
        + '</div>'
        + '</div>';
    });

    cartBody.innerHTML = html;
    if (cartSubtotal) {
      var currencySuffix = (window.Medico && window.Medico.currency && window.Medico.currency.iso_code) || 'USD';
      cartSubtotal.textContent = money(cart.total_price) + ' ' + currencySuffix;
    }

    // View cart btn href update
    var viewCartBtn = qs('#view-cart-btn');
    if (viewCartBtn) viewCartBtn.href = '/cart';

    // Bind qty events
    bindCartEvents();
  }

  function bindCartEvents() {
    if (!cartBody) return;

    // Minus, Plus, Delete buttons
    cartBody.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('.cart-qty-minus');
      var plusBtn = e.target.closest('.cart-qty-plus');
      var deleteBtn = e.target.closest('.cart-item__delete');

      if (minusBtn) {
        var key = minusBtn.dataset.key;
        var input = cartBody.querySelector('input[data-key="' + key + '"]');
        if (input) {
          var newQty = Math.max(0, parseInt(input.value, 10) - 1);
          updateCartItem(key, newQty, minusBtn);
        }
      }

      if (plusBtn) {
        var key = plusBtn.dataset.key;
        var input = cartBody.querySelector('input[data-key="' + key + '"]');
        if (input) {
          var newQty = parseInt(input.value, 10) + 1;
          updateCartItem(key, newQty, plusBtn);
        }
      }

      if (deleteBtn) {
        var key = deleteBtn.dataset.key;
        updateCartItem(key, 0, deleteBtn);
      }
    });

    // Manual qty input
    cartBody.addEventListener('change', function (e) {
      if (e.target.classList.contains('cart-item__qty-num')) {
        var key = e.target.dataset.key;
        var newQty = Math.max(0, parseInt(e.target.value, 10) || 0);
        updateCartItem(key, newQty, e.target);
      }
    });
  }

  function updateCartItem(key, qty, btn) {
    if (btn) btn.classList.add('loading');
    var itemRow = cartBody.querySelector('.cart-item[data-key="' + key + '"]');
    if (itemRow) itemRow.classList.add('loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) { renderCart(cart); });
      })
      .catch(function (err) {
        console.error('Cart update error:', err);
        if (btn) btn.classList.remove('loading');
        if (itemRow) itemRow.classList.remove('loading');
      });
  }

  // Cart instructions toggle
  var instructionsToggle = qs('#cart-instructions-toggle');
  var cartNote = qs('#cart-note');
  if (instructionsToggle && cartNote) {
    instructionsToggle.addEventListener('click', function () {
      var open = cartNote.style.display !== 'none';
      cartNote.style.display = open ? 'none' : 'block';
      this.classList.toggle('open', !open);
    });
    // Save note on change
    cartNote.addEventListener('change', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: cartNote.value })
      });
    });
  }

  // Open cart
  var cartTrigger = qs('#cart-trigger');
  var mobileCartTrigger = qs('#mobile-cart-trigger');
  var cartClose = qs('#cart-close');

  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (mobileCartTrigger) mobileCartTrigger.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', function () { closeSidebar(cartSidebar); });

  // Automatically open cart when item is added
  document.addEventListener('cart:updated', openCart);

  /* ======================================================
     COMPARE SIDEBAR
  ====================================================== */
  var compareItems = JSON.parse(localStorage.getItem('medico_compare') || '[]');
  var compareSidebar = qs('#compare-sidebar');
  var compareSidebarBody = qs('#compare-sidebar-body');
  var compareCount = qs('#compare-count');

  function updateCompareCount() {
    if (compareCount) compareCount.textContent = compareItems.length;
  }

  function renderCompareSidebar() {
    if (!compareSidebarBody) return;
    if (compareItems.length === 0) {
      compareSidebarBody.innerHTML = '<p class="compare-empty">No products added to compare yet.</p>';
      return;
    }
    var html = '';
    compareItems.forEach(function (item, index) {
      html += '<div class="compare-item">'
        + (item.image
          ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" class="compare-item__img">'
          : '<div class="compare-item__img-placeholder"></div>')
        + '<div class="compare-item__info">'
        + '<div class="compare-item__title">' + escHtml(item.title) + '</div>'
        + '<div class="compare-item__price">' + (item.price || '') + '</div>'
        + '</div>'
        + '<button class="compare-item__remove" data-index="' + index + '" aria-label="Remove from compare">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        + '</button>'
        + '</div>';
    });
    compareSidebarBody.innerHTML = html;

    // Remove buttons
    compareSidebarBody.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.compare-item__remove');
      if (removeBtn) {
        var idx = parseInt(removeBtn.dataset.index, 10);
        compareItems.splice(idx, 1);
        localStorage.setItem('medico_compare', JSON.stringify(compareItems));
        updateCompareCount();
        renderCompareSidebar();
      }
    });
  }

  // Public API for adding products to compare (call from product cards)
  window.MedicoCompare = {
    add: function (product) {
      var exists = compareItems.find(function (i) { return i.id === product.id; });
      if (!exists) {
        compareItems.push(product);
        if (compareItems.length > 4) compareItems.shift();
        localStorage.setItem('medico_compare', JSON.stringify(compareItems));
        updateCompareCount();
      }
    },
    remove: function (id) {
      compareItems = compareItems.filter(function (i) { return i.id !== id; });
      localStorage.setItem('medico_compare', JSON.stringify(compareItems));
      updateCompareCount();
    }
  };

  var compareTrigger = qs('#compare-trigger');
  var compareClose = qs('#compare-close');

  if (compareTrigger) {
    compareTrigger.addEventListener('click', function () {
      renderCompareSidebar();
      openSidebar(compareSidebar);
    });
  }
  if (compareClose) compareClose.addEventListener('click', function () { closeSidebar(compareSidebar); });

  updateCompareCount();

  /* ======================================================
     OVERLAY CLICK → CLOSE SIDEBARS
  ====================================================== */
  if (sidebarOverlay) {
    sidebarOverlay.addEventListener('click', closeAllSidebars);
  }

  /* ======================================================
     MOBILE DRAWER
  ====================================================== */
  var mobileDrawer = qs('#mobile-drawer');
  var mobileDrawerClose = qs('#mobile-drawer-close');
  var mobileMenuBtn = qs('#mobile-menu-btn');
  var mobileOverlay = qs('#mobile-overlay');

  function openMobileDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.classList.add('sidebar-open');
  }
  function closeMobileDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.classList.remove('sidebar-open');
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileDrawer);
  if (mobileDrawerClose) mobileDrawerClose.addEventListener('click', closeMobileDrawer);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileDrawer);

  /* ======================================================
     ESC KEY
  ====================================================== */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllSidebars();
      closeMobileDrawer();
      closeAllPopups();
    }
  });

  /* ======================================================
     WISHLIST COUNT (reads from localStorage, works
     with any wishlist app that stores to 'wishlist')
  ====================================================== */
  function updateWishlistCount() {
    var wishlistCount = qs('#wishlist-count');
    if (!wishlistCount) return;
    try {
      var saved = JSON.parse(localStorage.getItem('wishlist') || '[]');
      wishlistCount.textContent = Array.isArray(saved) ? saved.length : 0;
    } catch (e) {
      wishlistCount.textContent = 0;
    }
  }
  updateWishlistCount();

  /* ======================================================
     ALL CATEGORIES DROPDOWN
  ====================================================== */
  function initCategoriesDropdown() {
    var wrap = qs('#nav-cat-wrap');
    var triggers = [qs('#categories-trigger'), qs('#mobile-categories-trigger')].filter(Boolean);
    var dropdown = qs('#categories-dropdown');
    if (triggers.length === 0 || !dropdown) return;

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Close others if needed
        closeAllPopups();
        
        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('active');
          dropdown.setAttribute('aria-hidden', 'true');
        } else {
          // If mobile trigger, we might want to close mobile drawer?
          // For now just toggle
          trigger.setAttribute('aria-expanded', 'true');
          dropdown.classList.add('active');
          dropdown.setAttribute('aria-hidden', 'false');
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) {
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('active');
        dropdown.setAttribute('aria-hidden', 'true');
      }
    });

    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('active');
        dropdown.setAttribute('aria-hidden', 'true');
      }
    });
  }

  initCategoriesDropdown();

  /* ======================================================
     MOBILE DRAWER ACCORDION
  ====================================================== */
  function initMobileAccordion() {
    var drawer = qs('#mobile-drawer');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      var trigger = e.target.closest('.mob-drawer__link');
      if (!trigger) return;

      var sub = trigger.nextElementSibling;
      if (sub && sub.classList.contains('mob-drawer__sub')) {
        e.preventDefault(); // Prevent navigation on parent links with submenus
        var isActive = sub.classList.contains('active');
        
        // Toggle this one
        trigger.classList.toggle('active');
        sub.classList.toggle('active');
      }
    });
  }

  initMobileAccordion();

  /* ======================================================
     MOBILE BOTTOM BAR INTERACTIONS
  ====================================================== */
  function initMobileBottomBar() {
    var searchTrigger = qs('#mbb-search-trigger');
    var mbbCartTrigger = qs('#mbb-cart-trigger');
    var searchRoot = qs('#mobile-search-input');

    if (searchTrigger) {
      searchTrigger.addEventListener('click', function() {
        if (searchRoot) {
          searchRoot.focus();
          searchRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    if (mbbCartTrigger) {
      mbbCartTrigger.addEventListener('click', function() {
        var cartBtn = qs('#cart-trigger') || qs('#mobile-cart-trigger');
        if (cartBtn) cartBtn.click();
      });
    }
  }

  initMobileBottomBar();

  /* ======================================================
     CURRENCY LOADING OVERLAY (shown while page reloads)
  ====================================================== */
  function showCurrencyLoadingOverlay(flag, symbol, code) {
    var existing = qs('#currency-reload-overlay');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.id = 'currency-reload-overlay';
    el.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:99999',
      'background:rgba(255,255,255,0.92)',
      'backdrop-filter:blur(4px)',
      '-webkit-backdrop-filter:blur(4px)',
      'display:flex',
      'flex-direction:column',
      'align-items:center',
      'justify-content:center',
      'gap:12px',
      'font-family:\'Outfit\',sans-serif'
    ].join(';');

    el.innerHTML =
      '<div style="font-size:42px;line-height:1;">' + (flag || '🌐') + '</div>' +
      '<div style="font-size:18px;font-weight:700;color:#111;letter-spacing:-0.3px;">' +
        (symbol || '') + ' ' + (code || '') +
      '</div>' +
      '<div style="font-size:13px;color:#888;margin-top:4px;">Applying currency...</div>' +
      '<div style="' +
        'width:36px;height:36px;border-radius:50%;' +
        'border:3px solid #e5e5e5;border-top-color:#0C9B8E;' +
        'animation:currency-spin 0.7s linear infinite;margin-top:8px;' +
      '"></div>';

    /* inject keyframes once */
    if (!qs('#currency-spin-style')) {
      var style = document.createElement('style');
      style.id = 'currency-spin-style';
      style.textContent = '@keyframes currency-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(style);
    }

    document.body.appendChild(el);
  }

  /* ======================================================
     CURRENCY MODAL (AJAX — reloads same page after switch)
  ====================================================== */
  function initCurrencyModal() {
    var overlay   = qs('#currency-modal-overlay');
    var modal     = qs('#currency-modal');
    var closeBtn  = qs('#currency-modal-close');
    var searchInput = qs('#currency-search-input');
    var list      = qs('#currency-modal-list');
    var triggers  = qsa('.currency-modal-trigger');

    if (!overlay || !modal) return;

    /* --- open --- */
    function openModal() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sidebar-open');
      if (searchInput) {
        searchInput.value = '';
        filterList('');
        setTimeout(function() { searchInput.focus(); }, 180);
      }
    }

    /* --- close --- */
    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sidebar-open');
    }

    triggers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        openModal();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    /* close on overlay backdrop click */
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    /* close on ESC */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    /* --- search filter --- */
    function filterList(query) {
      if (!list) return;
      var q = query.toLowerCase().trim();
      qsa('.currency-option', list).forEach(function(opt) {
        var code = (opt.dataset.code || '').toLowerCase();
        var name = (opt.dataset.name || '').toLowerCase();
        var symbol = (opt.dataset.symbol || '').toLowerCase();
        var match = !q || code.indexOf(q) !== -1 || name.indexOf(q) !== -1 || symbol.indexOf(q) !== -1;
        opt.classList.toggle('is-hidden', !match);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        filterList(this.value);
      });
    }

    /* --- AJAX currency switch --- */
    if (list) {
      list.addEventListener('click', function(e) {
        var opt = e.target.closest('.currency-option');
        if (!opt) return;

        var code   = opt.dataset.code;
        var symbol = opt.dataset.symbol;
        var name   = opt.dataset.name;
        var flag   = opt.dataset.flag;

        if (!code) return;

        /* Mark all triggers as loading */
        triggers.forEach(function(btn) { btn.classList.add('is-loading'); });

        /* Close modal immediately for snappy UX */
        closeModal();

        /* AJAX: POST to /cart/update to switch currency */
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ currency: code })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          /*
           * Shopify prices are rendered server-side by Liquid.
           * The only way to reflect updated currency across all
           * page prices is to reload the same URL.
           * The session cookie already has the new currency set,
           * so the reload will render everything in the new currency.
           */
          showCurrencyLoadingOverlay(flag, symbol, code);
          window.location.reload();
        })
        .catch(function(err) {
          console.error('Currency switch error:', err);
          triggers.forEach(function(btn) { btn.classList.remove('is-loading'); });
          /* Still try a reload — session may have been updated */
          window.location.reload();
        });
      });
    }
  }

  initCurrencyModal();

})();

